import RetencionList from './RetencionList'
export {RetencionList}
export default RetencionList
